export const APP_VERSION_KEY = "appVersion"